import React from 'react';
import { Chip } from '@leap4/frontend';

interface SelectableChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

export const SelectableChip: React.FC<SelectableChipProps> = ({ label, selected, onClick }) => {
  return (
    <Chip
      label={label}
      onClick={onClick}
      variant={selected ? 'filled' : 'outlined'}
      color={selected ? 'primary' : 'default'}
      sx={{
        cursor: 'pointer',
        fontWeight: 500,
        fontSize: 13,
        height: 32,
        borderRadius: '6px',
        transition: 'all 0.15s',
        ...(selected
          ? {
              bgcolor: 'primary.main',
              color: 'white',
              '&:hover': { bgcolor: 'primary.dark' },
            }
          : {
              bgcolor: 'background.paper',
              borderColor: 'divider',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'action.hover',
              },
            }),
      }}
    />
  );
};
